


















import Vue from 'vue';
import {Component} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';


@Component({
  components: {},
})
export default class PropertyDisplayer extends Vue {
  @Prop()
  private title!: string;

  @Prop()
  private value!: string;

  @Prop({default: null})
  private details!: string | null;

  @Prop({type: String, default: null})
  private statusColor!: string | null;

  @Prop({default: false})
  private loading!: boolean;
}
